export class  Team  {
    public TeamData = {
    'active': true,
    'teamDetail': {
        'name': '',
        'size': 1,
        'description': '',
        'teamLevel': '',
        'teamLeader': {
            'id': ''
        },
        'parentTeam': {
            'teamId': '',
            'name': ''
        },
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': {}
        }
    },
    'members': {
        'associates': [],
        'lastEditedBy': {
            'name': '',
            'id': '',
            'time': {}
        }
    },
    'lastEdited': [{
        'name': '',
        'id': '',
        'time': ''
    }],
    'lastArchived': [{
        'name': '',
        'id': '',
        'time': ''
    }],
    'lastArchivedBy': {
        'name': '',
        'id': '',
        'time': ''
    },
    'created': ''
}
} ;
